<template>
    <div class="misc-inner p-2 p-sm-3">
        <div class="w-100 text-center">
            <h3 class="mb-5">
                شما به این بخش دسترسی ندارید!
            </h3>
            <b-img fluid :src="imgUrl" />
        </div>
    </div>
</template>

<script>
import { BImg } from 'bootstrap-vue'
import store from '@/store/index'

export default {
    components: {
        BImg,
    },
    data() {
        return {
            downImg: require('@/assets/images/pages/not-authorized.svg'),
        }
    },
    computed: {
        imgUrl() {
            if (store.state.appConfig.layout.skin === 'dark') {
                this.downImg = require('@/assets/images/pages/not-authorized-dark.svg')
                return this.downImg
            }
            return this.downImg
        },
    },
}
</script>